<template>
  <v-row no-gutters>
    <v-col v-for="button in items" :key="button.name" style="padding: 0 2px; height: 24px;">
      <the-navbar-tools-panel-item v-bind="button" v-on="$listeners">
        <template #default="button">
          <slot :name="button.name" v-bind="button"> </slot>
        </template>
      </the-navbar-tools-panel-item>
    </v-col>
  </v-row>
</template>

<script>
import TheNavbarToolsPanelItem from '@/components/TheNavbarToolsPanelItem';

export default {
  name: 'TheNavbarToolsPanelItems',
  components: {
    TheNavbarToolsPanelItem,
  },
  props: {
    items: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped></style>
